<template>
  <div id="ScannedPetGallery" >
  <div class="pet-image cell" v-for="(img, idx) in pet_gallery" :key="idx" :style="{'background-image': 'url(' + img.filepath + ')'}" @click="enlargeImg(img.filepath)">
  </div>
  </div>
</template>
<script>
export default{
  name: 'ScannedPetGallery',
  props:['pet_gallery'],
  data(){
    return{
      // pet_banner: 'https://images.unsplash.com/photo-1586326709898-0a344840a314?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
      show_Bedit: true,
    }
  },
  methods:{
    enlargeImg(val){
      this.$emit('enlargeImg', val)
    }
  },
  computed:{
    // placeholderGallery:{
    //   get(){
    //     let base_count = 15
    //     base_count = base_count - this.pet_gallery.length
    //     return base_count
    //    },
    //    set(value)
    //    {
    //      let base_count = value
    //      return base_count
    //    }
    // },
  }
}
</script>
<style scoped>
#ScannedPetGallery{
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr;

  grid-column-gap: 0px;
  grid-row-gap: 0px;
  justify-items: center;
  align-items: center;
  margin-bottom: -5rem;
  z-index: 0;
}
.pet-image:hover{
  cursor: pointer;
  transform: translateY(-4px);
  -webkit-box-shadow: 13px 17px 33px -23px rgba(0,0,0,0.75);
  -moz-box-shadow: 13px 17px 33px -23px rgba(0,0,0,0.75);
  box-shadow: 13px 17px 33px -23px rgba(0,0,0,0.75);
}
.cell{
  width:100%;
  height: 100%;
  min-width: 25rem;
  min-height: 25rem;
  margin: 0;
  /* border-radius: 10px; */
  overflow:hidden;
  position: relative;
  /* Create the parallax scrolling effect */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content:center;
  align-items:center;
  text-align: center;
  transition: 1s;
}
.add-sign{
  min-width: 15rem;
  min-height: 15rem;
  margin: 0 auto;
  /* border-radius: 5px; */
  background-color: #fff;
}
.add-img-cell{
  background-color: #e5e5e5;
}
.emp{
  border:none;
}
/*----------------------*\
|     PROFILE BANNER END
\*----------------------*/
@media only screen and (max-width: 600px) {
  #ScannedPetGallery{
    width: 99%;
  }
  .cell{
    min-width: 10rem;
    min-height: 10rem;
  }
}
</style>
